import React from 'react';
import Head from 'next/head';
import HomePage from '~/widgets/home';
import useCheckAuthorization from '~/shared/hooks/useCheckAuthorization';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';

const HomepageDefaultPage = () => {
    useCheckAuthorization();
    const { t } = useTranslation('common');

    return (
        <div className="ps-page--my-account">
            <Head>
                <title
                    aria-label="Sell ​​your Intellectual Property on Soff and earn"
                    aria-level={1}>
                    {t('meta.title')}
                </title>
                <meta
                    name="description"
                    content={t('meta.description')}
                />
                <meta
                    name="keywords"
                    content={t('meta.keywords')}
                />
            </Head>
            <HomePage />
        </div>
    );
};

export async function getServerSideProps({ locale }: { locale: string }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}

export default HomepageDefaultPage;
